import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import { useSnackbar, Stack, Typography } from '@emburse/embark-core';
import { $t, useTranslation } from '../../hooks/useTranslation';
import { getPageloadObject } from '../../api/audit';
import CorpAuditConfigInquirySettings from './CorpAuditConfigInquirySettings';
import CorpAuditConfigDetectionRules from './CorpAuditConfigDetectionRules';
import SingleColumnLayout from '../../components/Layouts/SingleColumnLayout';
function CorpAuditConfig() {
    useTranslation();
    const { enqueueSnackbar } = useSnackbar();
    const [pageloadData, setPageloadData] = useState(null);
    const refreshPageloadData = useCallback(async () => {
        try {
            const requestedPageloadData = await getPageloadObject();
            requestedPageloadData.AuditDefs = requestedPageloadData.AuditDefs.map((item) => ({
                ...item,
                id: item.AuditDefPK
            }));
            setPageloadData(requestedPageloadData);
        }
        catch (error) {
            enqueueSnackbar($t('Failed to load audit configuration data. ' +
                'Please try refreshing the page or contacting support if the issue persists.'), { variant: 'error' });
        }
    }, [enqueueSnackbar]);
    useEffect(() => {
        (async () => {
            await refreshPageloadData();
        })();
    }, [refreshPageloadData]);
    return (_jsx(SingleColumnLayout, { children: _jsxs(Stack, { alignItems: "flex-start", spacing: 6, children: [_jsx(Typography, { variant: "h4", children: $t('InstantAudit Configuration') }), _jsx(CorpAuditConfigInquirySettings, { pageloadData: pageloadData }), _jsx(CorpAuditConfigDetectionRules, { pageloadData: pageloadData, refreshPageloadData: refreshPageloadData })] }) }));
}
export default CorpAuditConfig;
